import React from 'react';
import { teachers } from '../../mock/data';
import { Cloud, Star, Flower, Squirrel, Bird } from './Decor';

const Teachers = () => {
  // Marquee names
  const looped = [...teachers, ...teachers];

  return (
    <section id="guru" className="relative overflow-hidden pt-24 pb-32" style={{ background: 'linear-gradient(180deg, #fff4d1 0%, #ffe3a8 55%, #ffd7a0 100%)' }}>
      <div className="absolute inset-0 pointer-events-none">
        <Cloud size={240} className="absolute top-10 right-[-30px] animate-cloud-rev" />
        <Cloud size={200} className="absolute bottom-24 left-[-20px] animate-cloud" />
        <Star size={26} className="absolute top-16 left-[10%] animate-twinkle" />
        <Flower size={54} className="absolute top-[20%] right-[6%] animate-float" color="#ff9ec2" />
        <Flower size={44} className="absolute top-[52%] left-[3%] animate-float" color="#a8e6a1" />
        <div className="absolute bottom-16 right-[4%] animate-float"><Squirrel size={90} /></div>
        <div className="absolute bottom-12 left-[6%] animate-bird"><Bird size={64} flip /></div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-[820px] mx-auto">
          <div className="font-hand text-[15px] tracking-[0.35em] text-[#2b8b98] mb-2">GURU KAMI</div>
          <h2 className="font-brush text-[46px] md:text-[64px] leading-[1] text-[#c74a2a]">
            Bertemu Tim Ceria
          </h2>
          <p className="mt-4 font-hand text-[18px] text-[#4a3b2a]/85">
            Guru-guru yang berdedikasi, sabar, dan penuh ide kreatif menemani hari-hari anak.
          </p>
        </div>

        {/* Loop text top */}
        <div className="mt-10 overflow-hidden py-2">
          <div className="flex whitespace-nowrap animate-marquee">
            {Array.from({ length: 2 }).map((_, k) => (
              <div key={k} className="flex items-center gap-10 pr-10 font-brush text-[60px] md:text-[80px] text-[#ff9a4d]">
                <span>Our Teachers</span>
                <span className="text-[#e04a2a]">✦</span>
                <span>Guru Kami</span>
                <span className="text-[#e04a2a]">✦</span>
                <span>Our Teachers</span>
                <span className="text-[#e04a2a]">✦</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {teachers.map((t, i) => (
            <div
              key={t.name}
              className="group relative bg-white rounded-[28px] p-5 pb-6 border-4 border-white shadow-[0_10px_0_rgba(200,120,60,0.20)] hover:-translate-y-2 transition-transform duration-500"
            >
              <div
                className="h-40 rounded-[20px] flex items-end justify-center relative overflow-hidden"
                style={{ background: t.color }}
              >
                {/* Avatar illustration */}
                <svg viewBox="0 0 120 160" width="120" className="absolute bottom-0" aria-hidden="true">
                  {/* head */}
                  <circle cx="60" cy="52" r="30" fill="#f4d3b0" />
                  {/* hair */}
                  <path d="M28 48 Q30 20 60 20 Q90 20 92 48 Q84 34 60 34 Q36 34 28 48 Z" fill="#3b2a1a" />
                  {/* eyes */}
                  <circle cx="50" cy="54" r="2.5" fill="#2a1a10" />
                  <circle cx="70" cy="54" r="2.5" fill="#2a1a10" />
                  {/* smile */}
                  <path d="M50 66 Q60 74 70 66" stroke="#c04a2a" strokeWidth="2" fill="none" strokeLinecap="round" />
                  {/* neck */}
                  <rect x="52" y="78" width="16" height="12" fill="#f4d3b0" />
                  {/* body/dress */}
                  <path d="M20 160 Q30 96 60 96 Q90 96 100 160 Z" fill={i % 2 === 0 ? '#c74a2a' : '#2b8b98'} />
                  {/* collar */}
                  <path d="M46 92 L60 108 L74 92 L60 100 Z" fill="#fff5c7" />
                </svg>
                {/* Sticker */}
                <div className="absolute top-3 right-3 rotate-6 bg-white rounded-full px-3 py-1 font-hand text-[12px] text-[#3a2a1a] shadow">
                  #{i + 1}
                </div>
              </div>
              <h3 className="mt-4 font-brush text-[26px] text-[#2b8b98] text-center">{t.name}</h3>
              <div className="text-center font-hand text-[13px] tracking-widest text-[#c74a2a]">{t.role}</div>
              <p className="mt-2 font-hand text-[14px] text-center text-[#4a3b2a]/80 leading-snug">
                “{t.line}”
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Teachers;
